export default "__VITE_ASSET__73e6af8a__"